import { CALL_API } from "admin/middlewares/api";

export const FINANCINGS_LIST_GET_REQUEST = "FINANCINGS_LIST_GET_REQUEST";
export const FINANCINGS_LIST_GET_SUCCESS = "FINANCINGS_LIST_GET_SUCCESS";
export const FINANCINGS_LIST_GET_ERROR = "FINANCINGS_LIST_GET_ERROR";

export function get_financings() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings",
      authenticatedRequest: true,
      types: [
        FINANCINGS_LIST_GET_REQUEST,
        FINANCINGS_LIST_GET_SUCCESS,
        FINANCINGS_LIST_GET_ERROR,
      ],
    },
  };
}

export function get_account_financings(accountId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/byaccount?accountId=" + accountId,
      authenticatedRequest: true,
      types: [
        FINANCINGS_LIST_GET_REQUEST,
        FINANCINGS_LIST_GET_SUCCESS,
        FINANCINGS_LIST_GET_ERROR,
      ],
    },
  };
}

export const LOANS_FOR_PAYOUT_REQUEST = "LOANS_FOR_PAYOUT_REQUEST";
export const LOANS_FOR_PAYOUT_SUCCESS = "LOANS_FOR_PAYOUT_SUCCESS";
export const LOANS_FOR_PAYOUT_ERROR = "LOANS_FOR_PAYOUT_ERROR";

export function get_loans_for_payout() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/for-payout",
      authenticatedRequest: true,
      types: [
        LOANS_FOR_PAYOUT_REQUEST,
        LOANS_FOR_PAYOUT_SUCCESS,
        LOANS_FOR_PAYOUT_ERROR,
      ],
      method: "GET",
    },
  };
}

export const FINANCING_LIST_CHANGE_PAGE = "FINANCING_LIST_CHANGE_PAGE";

export function change_financing_list_page(page, financingType) {
  return {
    type: FINANCING_LIST_CHANGE_PAGE,
    financingType,
    page,
  };
}

export const FINANCING_LIST_CHANGE_FILTER = "FINANCING_LIST_CHANGE_FILTER";

export function change_financing_list_filter(key, value, financingType) {
  let filter = {};
  filter[key] = value;

  return {
    type: FINANCING_LIST_CHANGE_FILTER,
    financingType,
    filter,
  };
}

export const FINANCING_CLOSE_REQUEST = "FINANCING_CLOSE_REQUEST";
export const FINANCING_CLOSE_SUCCESS = "FINANCING_CLOSE_SUCCESS";
export const FINANCING_CLOSE_ERROR = "FINANCING_CLOSE_ERROR";

export function close_financing(financingId, shouldUnpublish) {
  let success = shouldUnpublish
    ? { method: close_and_unpublish.bind(this, financingId) }
    : FINANCING_CLOSE_SUCCESS;

  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/close",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [FINANCING_CLOSE_REQUEST, success, FINANCING_CLOSE_ERROR],
    },
  };
}

export const FINANCING_OPEN_REQUEST = "FINANCING_OPEN_REQUEST";
export const FINANCING_OPEN_SUCCESS = "FINANCING_OPEN_SUCCESS";
export const FINANCING_OPEN_ERROR = "FINANCING_OPEN_ERROR";

export function open_financing(financingId, shouldPublish) {
  let success = shouldPublish
    ? { method: open_and_publish.bind(this, financingId, open) }
    : FINANCING_OPEN_SUCCESS;

  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/open",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [FINANCING_OPEN_REQUEST, success, FINANCING_OPEN_ERROR],
    },
  };
}

export const FINANCING_REGISTER_PAYOUT_REQUEST =
  "FINANCING_REGISTER_PAYOUT_REQUEST";
export const FINANCING_REGISTER_PAYOUT_SUCCESS =
  "FINANCING_REGISTER_PAYOUT_SUCCESS";
export const FINANCING_REGISTER_PAYOUT_ERROR =
  "FINANCING_REGISTER_PAYOUT_ERROR";

export function register_financing_payouts(financingIds) {
  const financingId = financingIds.pop();
  if (financingId) {
    return {
      [CALL_API]: {
        endpoint: "/api/admin/financings/confirmloanpayout",
        method: "POST",
        data: {
          FinancingId: financingId,
        },
        authenticatedRequest: true,
        types: [
          FINANCING_REGISTER_PAYOUT_REQUEST,
          {
            method: register_financing_payout_result.bind(
              this,
              FINANCING_REGISTER_PAYOUT_SUCCESS,
              financingIds,
              { FinancingId: financingId },
            ),
          },
          {
            method: register_financing_payout_result.bind(
              this,
              FINANCING_REGISTER_PAYOUT_ERROR,
              financingIds,
              { FinancingId: financingId },
            ),
          },
        ],
      },
    };
  }
}

function register_financing_payout_result(
  type,
  financingIds,
  dataSent,
  response,
) {
  return (dispatch) => {
    dispatch({ type, dataSent, response });
    const action = register_financing_payouts(financingIds);
    if (action) {
      dispatch(action);
    }
  };
}

export function register_financing_payout(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/confirmloanpayout",
      method: "POST",
      data: {
        FinancingId: financingId,
      },
      authenticatedRequest: true,
      types: [
        FINANCING_REGISTER_PAYOUT_REQUEST,
        FINANCING_REGISTER_PAYOUT_SUCCESS,
        FINANCING_REGISTER_PAYOUT_ERROR,
      ],
    },
  };
}

export const CANCEL_LOAN_PAYOUT_REQUEST = "CANCEL_LOAN_PAYOUT_REQUEST";
export const CANCEL_LOAN_PAYOUT_SUCCESS = "CANCEL_LOAN_PAYOUT_SUCCESS";
export const CANCEL_LOAN_PAYOUT_ERROR = "CANCEL_LOAN_PAYOUT_ERROR";

export function cancel_loan(loanId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/CancelLoan",
      method: "POST",
      data: { FinancingId: loanId },
      authenticatedRequest: true,
      types: [
        CANCEL_LOAN_PAYOUT_REQUEST,
        CANCEL_LOAN_PAYOUT_SUCCESS,
        CANCEL_LOAN_PAYOUT_ERROR,
      ],
    },
  };
}

export const FINANCING_PUBLISH_REQUEST = "FINANCING_PUBLISH_REQUEST";
export const FINANCING_PUBLISH_SUCCESS = "FINANCING_PUBLISH_SUCCESS";
export const FINANCING_PUBLISH_ERROR = "FINANCING_PUBLISH_ERROR";

function open_and_publish(financingId) {
  return (dispatch) => {
    dispatch({
      type: FINANCING_OPEN_SUCCESS,
      financingId,
    });
    dispatch(publish_financing(financingId));
  };
}

export function publish_financing(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/publish",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        FINANCING_PUBLISH_REQUEST,
        FINANCING_PUBLISH_SUCCESS,
        FINANCING_PUBLISH_ERROR,
      ],
    },
  };
}

export const FINANCING_UNPUBLISH_REQUEST = "FINANCING_UNPUBLISH_REQUEST";
export const FINANCING_UNPUBLISH_SUCCESS = "FINANCING_UNPUBLISH_SUCCESS";
export const FINANCING_UNPUBLISH_ERROR = "FINANCING_UNPUBLISH_ERROR";

function close_and_unpublish(financingId) {
  return (dispatch) => {
    dispatch({
      type: FINANCING_CLOSE_SUCCESS,
      financingId,
    });
    dispatch(unpublish_financing(financingId));
  };
}

export function unpublish_financing(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/unpublish",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        FINANCING_UNPUBLISH_REQUEST,
        FINANCING_UNPUBLISH_SUCCESS,
        FINANCING_UNPUBLISH_ERROR,
      ],
    },
  };
}

export const CANCEL_FINANCING_REQUEST = "CANCEL_FINANCING_REQUEST";
export const CANCEL_FINANCING_SUCCESS = "CANCEL_FINANCING_SUCCESS";
export const CANCEL_FINANCING_ERROR = "CANCEL_FINANCING_ERROR";

export function cancel_financing(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/cancel",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        CANCEL_FINANCING_REQUEST,
        CANCEL_FINANCING_SUCCESS,
        CANCEL_FINANCING_ERROR,
      ],
    },
  };
}

export const FINANCING_PAYOUT_INFO_REQUEST = "FINANCING_PAYOUT_INFO_REQUEST";
export const FINANCING_PAYOUT_INFO_SUCCESS = "FINANCING_PAYOUT_INFO_SUCCESS";
export const FINANCING_PAYOUT_INFO_ERROR = "FINANCING_PAYOUT_INFO_ERROR";

export function get_financing_payout_info(financingId) {
  let url = `/api/admin/financings/loanstep/payout-info?financingId=${financingId}`;
  return {
    [CALL_API]: {
      endpoint: url,
      method: "GET",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        FINANCING_PAYOUT_INFO_REQUEST,
        FINANCING_PAYOUT_INFO_SUCCESS,
        FINANCING_PAYOUT_INFO_ERROR,
      ],
    },
  };
}

export const FINANCING_BOOKING_ACCOUNT_INFO_REQUEST =
  "FINANCING_BOOKING_ACCOUNT_INFO_REQUEST";
export const FINANCING_BOOKING_ACCOUNT_INFO_SUCCESS =
  "FINANCING_BOOKING_ACCOUNT_INFO_SUCCESS";
export const FINANCING_BOOKING_ACCOUNT_INFO_ERROR =
  "FINANCING_BOOKING_ACCOUNT_INFO_ERROR";

export function get_financing_booking_account_info(accountId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/accountinfo/byaccountid?accountId=" + accountId,
      method: "GET",
      authenticatedRequest: true,
      types: [
        FINANCING_BOOKING_ACCOUNT_INFO_REQUEST,
        FINANCING_BOOKING_ACCOUNT_INFO_SUCCESS,
        FINANCING_BOOKING_ACCOUNT_INFO_ERROR,
      ],
    },
  };
}

export const FINANCING_INVESTMENT_INFO_REQUEST =
  "FINANCING_INVESTMENT_INFO_REQUEST";
export const FINANCING_INVESTMENT_INFO_SUCCESS =
  "FINANCING_INVESTMENT_INFO_SUCCESS";
export const FINANCING_INVESTMENT_INFO_ERROR =
  "FINANCING_INVESTMENT_INFO_ERROR";

export function get_investment_info(creditId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/investments?creditId=" + creditId,
      method: "GET",
      authenticatedRequest: true,
      types: [
        FINANCING_INVESTMENT_INFO_REQUEST,
        FINANCING_INVESTMENT_INFO_SUCCESS,
        FINANCING_INVESTMENT_INFO_ERROR,
      ],
    },
  };
}

export const FINANCING_REALISE_REQUEST = "FINANCING_REALISE_REQUEST";
export const FINANCING_REALISE_SUCCESS = "FINANCING_REALISE_SUCCESS";
export const FINANCING_REALISE_ERROR = "FINANCING_REALISE_ERROR";

export function realise_financing(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/realise",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        FINANCING_REALISE_REQUEST,
        FINANCING_REALISE_SUCCESS,
        FINANCING_REALISE_ERROR,
      ],
    },
  };
}
